type LegalDisclaimerProps = {
  readonly text: ReadonlyArray<string>
}

export function LegalDisclaimer({ text }: LegalDisclaimerProps) {
  return (
    <p
      className="m-0 mt-3 text-xs font-light leading-relaxed text-neutral-dark text-center"
      data-component="LegalDisclaimer"
    >
      {text.map(line => (
        <span key={line} className="block">
          {line}
        </span>
      ))}
    </p>
  )
}
